module.exports = __webpack_public_path__ + "static/img/zhangjunyi6.38da910.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/zhangjunyi6.jpg
// module id = SGDX
// module chunks = 1